import { dateRequiredSchema, statusSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object, string } from 'yup';
import { isHTMLContentEmpty } from "helpers/common";

const notesValidation = object().shape({
    title: stringRequiredSchema,
    description: string()
        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
        .required('This field is required'),
    date: dateRequiredSchema
    // status: statusSchema
});

export default notesValidation;